<template>
  <div class="c-enbek-extra-form" :class="{ 'with-dropdown': dropdownSpace }" @click.capture="revealOpenedDropdown">
    <n-loader :loading="loading" />

    <div class="km-field">
      <label>ID трудового договора в Енбек</label>
      <input v-model="form.contractId" type="text" class="km-input" placeholder="Определяется автоматически, можно указать вручную">
      <div v-if="baseContracts.length > 1" class="km-chips">
        <span v-for="item in baseContracts" :key="item.id" class="km-chip" @click="selectBaseContract(item)">
          ТД №{{ item.number }} · {{ item.enbekId }}
        </span>
      </div>
    </div>

    <!-- расторжение -->
    <template v-if="operation === 'terminationContract'">
      <div class="km-field">
        <label>Дата расторжения</label>
        <input v-model="form.terminationDate" type="date" class="km-input">
        <div class="km-note">Задним числом — не более 10 календарных дней</div>
      </div>
      <div class="km-field">
        <label>Причина расторжения <span class="km-optional">(необязательно, справочник ТК РК)</span></label>
        <n-select
          class="new-select"
          :value.sync="form.terminationReason"
          :data="reasonOptions"
          placeholder="Не указывать" />
      </div>
      <div class="km-check">
        <c-checkbox
          :checked.sync="form.termReasonDigitalization"
          title="Расторжение в связи с цифровизацией (внедрением новых технологий)" />
      </div>
    </template>

    <!-- восстановление -->
    <template v-else-if="operation === 'restoreContract'">
      <div class="km-field">
        <label>Дата расторжения, которое отменяется</label>
        <input v-model="form.terminationDate" type="date" class="km-input">
      </div>
      <div class="km-field">
        <label>Дата восстановления</label>
        <input v-model="form.restoreDate" type="date" class="km-input">
      </div>
      <div class="km-field">
        <label>Номер приказа о восстановлении</label>
        <input v-model="form.orderNumber" type="text" class="km-input" :placeholder="String(eDocument.number || '')">
      </div>
      <div class="km-field">
        <label>Основание восстановления</label>
        <n-select
          class="new-select"
          :value.sync="form.restoreOrganizationType"
          :data="organizationOptions"
          placeholder="Выберите основание" />
      </div>
      <div v-if="organizationType === '1'" class="km-field">
        <label>Суд</label>
        <n-select
          class="new-select"
          :value.sync="form.court"
          :data="courtOptions"
          placeholder="Начните вводить название суда" />
      </div>
      <div class="km-field">
        <label>Комментарий <span class="km-optional">(причина восстановления / ошибочного расторжения, обязателен)</span></label>
        <textarea v-model="form.restoreNote" class="km-input" rows="3" placeholder="Например: восстановлен по решению суда от …"></textarea>
      </div>
    </template>

    <!-- продление -->
    <template v-else-if="operation === 'prolongationContract'">
      <div class="km-field">
        <label>Дата продления</label>
        <input v-model="form.prolongationDate" type="date" class="km-input">
        <div class="km-note">С какой даты действует продление: обычно совпадает с датой окончания предыдущего срока договора</div>
      </div>
      <div class="km-field">
        <label>Срок договора после продления</label>
        <n-select
          class="new-select"
          :value.sync="form.dContractDate"
          :data="contractTermOptions"
          placeholder="Выберите срок" />
        <div v-if="baseTermHint" class="km-note">{{ baseTermHint }}</div>
      </div>
      <div v-if="contractTerm === '2' || contractTerm === '3'" class="km-field">
        <label>Дата окончания продлённого срока</label>
        <input v-model="form.prolongationEndDate" type="date" class="km-input">
      </div>
    </template>

    <!-- социальный отпуск -->
    <template v-else-if="operation === 'socialLeave'">
      <div class="km-callout">
        Данные соц. отпуска используются для назначения соц. выплат. Проверьте их тщательно: после передачи в другую ИС
        удалить запись нельзя.
      </div>
      <div class="km-field">
        <label>Тип социального отпуска</label>
        <n-select
          class="new-select"
          :value.sync="form.dSocialLeaveTypeId"
          :data="leaveTypeOptions"
          placeholder="Выберите тип" />
      </div>
      <div class="km-field">
        <label>Не работал с</label>
        <input v-model="form.beginDate" type="date" class="km-input">
      </div>
      <div class="km-field">
        <label>Не работал по</label>
        <input v-model="form.endDate" type="date" class="km-input">
      </div>
      <div class="km-field">
        <label>Дата первого рабочего дня <span v-if="leaveType === '1'" class="km-optional">(обязательно)</span></label>
        <input v-model="form.workDate" type="date" class="km-input">
      </div>
      <div class="km-field">
        <label>Номер табеля <span class="km-optional">{{ leaveType === '1' ? '(обязательно)' : '(необязательно)' }}</span></label>
        <input v-model="form.sheetNumber" type="text" class="km-input">
      </div>
      <div class="km-field">
        <label>Выходные дни за период нетрудоспособности <span class="km-optional">(необязательно)</span></label>
        <input v-model="form.daysOffCount" type="number" min="0" class="km-input">
      </div>
      <div class="km-field">
        <label>Отдел, рус. <span class="km-optional">(необязательно)</span></label>
        <input v-model="form.departmentNameRu" type="text" class="km-input">
      </div>
      <div class="km-field">
        <label>Отдел, каз. <span class="km-optional">(необязательно)</span></label>
        <input v-model="form.departmentNameKz" type="text" class="km-input">
      </div>
    </template>
  </div>
</template>

<script>
// дата из метаданных документа (ISO-строка Carbon в UTC, например «2026-10-04T19:00:00Z») →
// значение для <input type="date"): календарный день берём в местном часовом поясе, а не обрезкой строки
const toInputDate = (value) => {
  if (!value) return ''
  const date = new Date(value)
  if (isNaN(date.getTime())) return String(value).slice(0, 10)
  const pad = (number) => String(number).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

export default {
  name: 'CEnbekExtraForm',
  props: {
    // terminationContract | restoreContract | socialLeave | prolongationContract
    operation: { type: String, required: true, },
    eDocument: { type: Object, required: true, },
    // трудовые договоры сотрудника, зарегистрированные в Енбек (из enbek/context)
    baseContracts: { type: Array, default: () => [], },
    // дата последнего расторжения сотрудника (для формы восстановления)
    suggestedTerminationDate: { type: String, default: '', },
  },
  data() {
    const meta = (this.eDocument.eDocumentMeta && this.eDocument.eDocumentMeta.metadata) || {}
    const metaDate = (key) => toInputDate(meta[key + 'Carbon'] || meta[key])
    return {
      loading: false,
      dropdownSpace: false,
      dictionaries: { termReasons: [], restoreOrganizationTypes: [], socialLeaveTypes: [], courts: [], contractTerms: [], },
      form: {
        contractId: '',
        terminationDate: this.operation === 'restoreContract' ? this.suggestedTerminationDate : metaDate('terminationDate'),
        terminationReason: null,
        termReasonDigitalization: false,
        restoreDate: metaDate('restoreDate'),
        prolongationDate: '',
        dContractDate: null,
        // в документе «prolongationDate» — дата, до которой продлевается договор
        prolongationEndDate: metaDate('prolongationDate'),
        orderNumber: '',
        restoreOrganizationType: null,
        court: null,
        restoreNote: '',
        dSocialLeaveTypeId: null,
        beginDate: metaDate('leaveDateFrom'),
        endDate: metaDate('leaveDateTo'),
        workDate: metaDate('leaveReturnDate'),
        sheetNumber: '',
        daysOffCount: '',
        departmentNameRu: '',
        departmentNameKz: '',
      },
    }
  },
  computed: {
    // n-select кладёт в значение весь вариант {value, title} — код берём из .value
    reasonOptions() {
      // группы-заголовки выбирать нельзя, поэтому только вложенные причины
      return this.dictionaries.termReasons
        .filter((reason) => !reason.isGroup)
        .map((reason) => ({ value: reason.code, title: `${reason.code} · ${reason.name}`, }))
    },
    organizationOptions() {
      return this.dictionaries.restoreOrganizationTypes.map((type) => ({ value: type.code, title: type.name, }))
    },
    courtOptions() {
      return this.dictionaries.courts.map((court) => ({ value: court.code, title: court.name, }))
    },
    leaveTypeOptions() {
      return this.dictionaries.socialLeaveTypes.map((type) => ({ value: type.code, title: `${type.code} · ${type.name}`, }))
    },
    contractTermOptions() {
      return this.dictionaries.contractTerms.map((term) => ({ value: term.code, title: `${term.code} · ${term.name}`, }))
    },
    contractTerm() {
      return this.scalar(this.form.dContractDate)
    },
    // исходный ТД, к которому относится продление: выбранный по ID либо единственный найденный
    baseContract() {
      const byId = this.baseContracts.find((item) => item.enbekId === this.form.contractId)
      return byId || (this.baseContracts.length === 1 ? this.baseContracts[0] : null)
    },
    baseTermHint() {
      const base = this.baseContract
      if (!base || !base.term) return ''
      const term = this.dictionaries.contractTerms.find((item) => item.code === base.term)
      return `Срок продления должен совпадать со сроком ТД: ${base.term}${term ? ' · ' + term.name : ''}`
    },
    organizationType() {
      return this.scalar(this.form.restoreOrganizationType)
    },
    leaveType() {
      return this.scalar(this.form.dSocialLeaveTypeId)
    },
  },
  watch: {
    baseContracts(list) {
      // единственный найденный договор подставляем сам
      if (!this.form.contractId && list.length === 1) this.form.contractId = list[0].enbekId
      if (list.length === 1) this.applyBaseDefaults(list[0])
    },
    suggestedTerminationDate(value) {
      if (this.operation === 'restoreContract' && !this.form.terminationDate) this.form.terminationDate = value
    },
  },
  created() {
    if (this.baseContracts.length === 1) this.form.contractId = this.baseContracts[0].enbekId
    this.loading = true
    $api.esutd.getDictionaries().then((response) => {
      this.dictionaries = response.data.content
      if (this.baseContracts.length === 1) this.applyBaseDefaults(this.baseContracts[0])
    }).finally(() => {
      this.loading = false
    })
  },
  methods: {
    // список раскрывается внутри прокручиваемой модалки и без запаса места уходит за её край:
    // пока список открыт, добавляем свободное место под формой и прокручиваем модалку к списку
    revealOpenedDropdown() {
      setTimeout(() => {
        this.dropdownSpace = !!this.$el.querySelector('.vs--open')
        if (!this.dropdownSpace) return
        this.$nextTick(() => {
          const menu = this.$el.querySelector('.vs__dropdown-menu')
          if (menu && menu.scrollIntoView) menu.scrollIntoView({ block: 'nearest', })
        })
      }, 120)
    },
    selectBaseContract(item) {
      this.form.contractId = item.enbekId
      this.applyBaseDefaults(item)
    },
    // продление: срок и дата продления подсказываются по исходному ТД (срок — тот же, дата — конец его срока, если он уже наступил)
    applyBaseDefaults(item) {
      if (this.operation !== 'prolongationContract' || !item) return
      if (item.term && !this.form.dContractDate) {
        const option = this.contractTermOptions.find((candidate) => candidate.value === item.term)
        if (option) this.form.dContractDate = option
      }
      const now = new Date()
      const pad = (number) => String(number).padStart(2, '0')
      const today = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`
      if (item.endDate && !this.form.prolongationDate && item.endDate <= today) {
        this.form.prolongationDate = item.endDate
      }
    },
    scalar(value) {
      return value && typeof value === 'object' ? value.value : (value || '')
    },
    // текст ошибки или пустая строка; остальное (диапазоны, справочники, правила ЕСУТД) проверяет бэкенд
    validate() {
      const form = this.form
      if (this.operation === 'terminationContract' && !form.terminationDate) return 'Укажите дату расторжения'
      if (this.operation === 'restoreContract') {
        if (!form.terminationDate || !form.restoreDate) return 'Укажите дату расторжения и дату восстановления'
        if (!this.organizationType) return 'Выберите основание восстановления'
        if (this.organizationType === '1' && !this.scalar(form.court)) return 'Выберите суд'
        if (!form.restoreNote.trim()) return 'Укажите комментарий по ошибочному расторжению'
      }
      if (this.operation === 'prolongationContract') {
        if (!form.prolongationDate) return 'Укажите дату продления'
        if (!this.contractTerm) return 'Выберите срок договора'
        if ([ '2', '3', ].includes(this.contractTerm) && !form.prolongationEndDate) {
          return 'Для договора на определённый срок укажите дату окончания продлённого срока'
        }
      }
      if (this.operation === 'socialLeave') {
        if (!this.leaveType) return 'Выберите тип социального отпуска'
        if (!form.beginDate || !form.endDate) return 'Укажите даты начала и окончания отпуска'
        if (this.leaveType === '1' && (!form.sheetNumber.trim() || !form.workDate)) {
          return 'Для отпуска по беременности и родам обязательны номер табеля и дата выхода на работу'
        }
      }
      return ''
    },
    // в запрос уходят только поля текущей операции
    getPayload() {
      const form = this.form
      const payload = { contractId: form.contractId, }
      if (this.operation === 'terminationContract') {
        Object.assign(payload, {
          terminationDate: form.terminationDate,
          terminationReason: this.scalar(form.terminationReason),
          termReasonDigitalization: form.termReasonDigitalization,
        })
      } else if (this.operation === 'prolongationContract') {
        Object.assign(payload, {
          prolongationDate: form.prolongationDate,
          dContractDate: this.contractTerm,
          endDate: [ '2', '3', ].includes(this.contractTerm) ? form.prolongationEndDate : '',
        })
      } else if (this.operation === 'restoreContract') {
        Object.assign(payload, {
          terminationDate: form.terminationDate,
          restoreDate: form.restoreDate,
          orderNumber: form.orderNumber,
          restoreOrganizationType: this.organizationType,
          court: this.organizationType === '1' ? this.scalar(form.court) : '',
          restoreNote: form.restoreNote,
        })
      } else {
        Object.assign(payload, {
          dSocialLeaveTypeId: this.leaveType,
          beginDate: form.beginDate,
          endDate: form.endDate,
          workDate: form.workDate,
          sheetNumber: form.sheetNumber,
          daysOffCount: form.daysOffCount === '' ? null : Number(form.daysOffCount),
          departmentNameRu: form.departmentNameRu,
          departmentNameKz: form.departmentNameKz,
        })
      }
      return payload
    },
  },
}
</script>

<style lang="scss" scoped>
// внешний вид полей, подсказок и чекбоксов задаёт c-kdo-modal (классы km-*)
.c-enbek-extra-form {
  position: relative;

  // выпадающий список раскрывается внутри прокручиваемой модалки: оставляем под формой место
  &.with-dropdown {
    padding-bottom: 260px;
  }
}
</style>
